import React, { useState } from "react";
import PropTypes from "prop-types";
import { MimaDateFilter } from "../MimaInput";
import { MimaButton } from "../Button";
import { ReceiptCheckBox as RCB } from "../Receipt";
import styles from "../../assets/styles/MimaFilter/MimaNewFilter.module.scss";
import { Formik } from "formik";
import MimaText from "../MimaText";
import { MdClose } from "react-icons/md";
import { IoMdAdd } from "react-icons/io";
import moment from "moment";
import { useMemo } from "react";
import { date, object, string } from "yup";
import { MimaDropdownFilter } from "../Dropdown";
import { MimaPaginatedDropdown } from "../MimaPaginatedDropDown";
import { businessStore } from "../../stores";

const propTypes = {
  value: PropTypes.any,
  name: PropTypes.string,
  variant: PropTypes.oneOf([
    "medium",
    "wide",
    "form",
    "mobile",
    "message",
    "exchange",
    "form2",
    "error",
  ]),
  textAreaVariant: PropTypes.oneOf(["type1", "type2", "type3"]),
  showFilter: PropTypes.bool,
  filterByData: PropTypes.array,
  filterHandler: PropTypes.func,
  statusParams: PropTypes.array,
};

const defaultProps = {
  handleFilter: (item, text) => {},
  filterByData: [
    { value: "Date", key: "createdAt" },
    { value: "Type", key: "type" },
  ],
  statusParams: [
    { value: "Open", key: "OPEN" },
    { value: "Closed", key: "CLOSED" },
  ],
};

// Value: Name you want to display, Key: api query.

const MimaNewFilter = ({
  showFilter,
  setShowFilter,
  filterByData,
  filterHandler,
  statusParams,
}) => {
  const [onReset, setOnReset] = useState(false);
  const [filterTags, setFilterTags] = useState([]);
  const [selectedFilterParam, setSelectedFilterParam] = useState(
    filterByData[0]
  );
  const [selectedParamIndex, setSelectedParamIndex] = useState(0);

  const goToFilterSelection = (item, i) => {
    setSelectedFilterParam(item);
    setSelectedParamIndex(i);
  };

  const validationSchema = () => {
    return object({
      selectedFilter: string().required("Please select a filter option"),
      startDate: date().when("selectedFilter", {
        is: "createdAt",
        then: date().required("Start date is required"),
      }),
      endDate: date().when("selectedFilter", {
        is: "createdAt",
        then: date().required("End date is required"),
      }),
      type: string().when("selectedFilter", {
        is: "type",
        then: string().required("Select a Type"),
      }),
      status: string().when("selectedFilter", {
        is: "status",
        then: string().required("Select a Status"),
      }),
      business: string().when("selectedFilter", {
        is: "business",
        then: string().required("Select a Business"),
      }),
      from: string().when("selectedFilter", {
        is: "from",
        then: string().required("Select a From Currency"),
      }),
      to: string().when("selectedFilter", {
        is: "to",
        then: string().required("Select a To Currency"),
      }),
    });
  };

  useMemo(() => {
    const createFilterQuery = () => {
      let query;

      if (filterTags.length === 1) {
        const filter = filterTags[0];

        if (filter.key === "createdAt") {
          query = `startDate=${filter.startDate}&endDate=${filter.endDate}`;
        } else if (filter.key === "type") {
          query = `${filter.key}=${filter.type}`;
        } else if (filter.key === "status") {
          query = `${filter.key}=${filter.status}`;
        } else if (filter.key === "business") {
          query = `${filter.key}=${filter.business}`;
        } else if (filter.key === "to") {
          query = `${filter.key}=${filter.to}`;
        } else if (filter.key === "from") {
          query = `${filter.key}=${filter.from}`;
        }
      } else if (filterTags.length > 1) {
        query = filterTags
          .map((filter) => {
            if (filter.key === "createdAt") {
              return `startDate=${filter.startDate}&endDate=${filter.endDate}`;
            } else if (filter.key === "type") {
              return `${filter.key}=${filter.type}`;
            } else if (filter.key === "status") {
              return `${filter.key}=${filter.status}`;
            } else if (filter.key === "business") {
              return `${filter.key}=${filter.business}`;
            } else if (filter.key === "to") {
              return `${filter.key}=${filter.to}`;
            } else if (filter.key === "from") {
              return `${filter.key}=${filter.from}`;
            }
          })
          .join("&");
      }

      filterHandler(query);
    };

    createFilterQuery();
  }, [filterTags, filterHandler]);

  const onSubmit = async (values) => {
    setShowFilter(false);
    let newAdd;
    if (selectedFilterParam.key === "createdAt") {
      newAdd = {
        ...selectedFilterParam,
        ...values,
        text: `Created between ${moment(values.startDate).format("MMM DD YYYY")} and ${moment(values.endDate).format("MMM DD YYYY")}`,
      };
      const index = filterTags.findIndex((filter) => filter.key === newAdd.key);

      if (index === -1) {
        setFilterTags([...filterTags, newAdd]);
      } else {
        const updatedFilterOptions = [...filterTags];
        updatedFilterOptions[index].text = newAdd.text;
        setFilterTags(updatedFilterOptions);
      }
    }
    if (selectedFilterParam.key === "type") {
      newAdd = {
        ...selectedFilterParam,
        ...values,
        text: `Transaction Type - ${values.type}`,
      };
      const index = filterTags.findIndex((filter) => filter.key === newAdd.key);

      if (index === -1) {
        setFilterTags([...filterTags, newAdd]);
      } else {
        const updatedFilterOptions = [...filterTags];
        updatedFilterOptions[index].text = newAdd.text;
        setFilterTags(updatedFilterOptions);
      }
    }
    if (selectedFilterParam.key === "status") {
      newAdd = {
        ...selectedFilterParam,
        ...values,
        text: `Status - ${values.status}`,
      };
      const index = filterTags.findIndex((filter) => filter.key === newAdd.key);

      if (index === -1) {
        setFilterTags([...filterTags, newAdd]);
      } else {
        const updatedFilterOptions = [...filterTags];
        updatedFilterOptions[index].text = newAdd.text;
        setFilterTags(updatedFilterOptions);
      }
    }
    if (selectedFilterParam.key === "business") {
      newAdd = {
        ...selectedFilterParam,
        ...values,
        text: `Business - ${values.tradingName}`,
      };
      const index = filterTags.findIndex((filter) => filter.key === newAdd.key);

      if (index === -1) {
        setFilterTags([...filterTags, newAdd]);
      } else {
        const updatedFilterOptions = [...filterTags];
        updatedFilterOptions[index].text = newAdd.text;
        setFilterTags(updatedFilterOptions);
      }
    }
    if (selectedFilterParam.key === "from") {
      newAdd = {
        ...selectedFilterParam,
        ...values,
        text: `From Currency - ${values.from}`,
      };
      const index = filterTags.findIndex((filter) => filter.key === newAdd.key);

      if (index === -1) {
        setFilterTags([...filterTags, newAdd]);
      } else {
        const updatedFilterOptions = [...filterTags];
        updatedFilterOptions[index].text = newAdd.text;
        setFilterTags(updatedFilterOptions);
      }
    }

    if (selectedFilterParam.key === "to") {
      newAdd = {
        ...selectedFilterParam,
        ...values,
        text: `To Currency - ${values.to}`,
      };
      const index = filterTags.findIndex((filter) => filter.key === newAdd.key);

      if (index === -1) {
        setFilterTags([...filterTags, newAdd]);
      } else {
        const updatedFilterOptions = [...filterTags];
        updatedFilterOptions[index].text = newAdd.text;
        setFilterTags(updatedFilterOptions);
      }
    }
  };

  //Remove tags
  const removeTags = (index) => {
    setFilterTags([
      ...filterTags.filter((tag) => filterTags.indexOf(tag) !== index),
    ]);
  };

  const closeFilter = () => {
    setShowFilter(false);
  };

  return (
    <div className={styles.filter}>
      <div className={styles.filter__tags}>
        {filterTags.length > 0 && <>Filter Tags</>}
        <div className={styles.tags}>
          {filterTags.map((tag, index) => (
            <div className={styles.singleTag} key={index}>
              <span>{tag.text}</span>
              <i onClick={() => removeTags(index)}>
                <MdClose />
              </i>
            </div>
          ))}
          <div className={styles.tagRelative}>
            {filterTags.length > 0 && (
              <div className={styles.singleTag}>
                <IoMdAdd
                  style={{ fontSize: "2rem" }}
                  onClick={() => setShowFilter(true)}
                />
              </div>
            )}

            {showFilter && (
              <div className={styles.filter__beside}>
                <Formik
                  initialValues={{
                    startDate: "",
                    endDate: "",
                    selectedFilter: selectedFilterParam.key,
                    type: "",
                    status: "",
                    business: "",
                    tradingName: "",
                  }}
                  validationSchema={validationSchema}
                  onSubmit={onSubmit}
                >
                  {({
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    setFieldValue,
                    values,
                    errors,
                    touched,
                  }) => (
                    <>
                      <div className={styles.filter__by}>
                        <MimaText
                          variant="small"
                          color="var(--color-primary)"
                          style={{ padding: "1rem" }}
                        >
                          Filter by
                        </MimaText>

                        {filterByData.map((x, i) => (
                          <li
                            key={i}
                            className={`${styles.filter__by__list} ${selectedParamIndex === i && styles.filter__by__list__active}`}
                            onClick={() => {
                              goToFilterSelection(x, i);
                              setFieldValue("selectedFilter", x.key);
                            }}
                          >
                            {x.value}
                          </li>
                        ))}
                      </div>

                      <div className={styles.filter__action}>
                        {selectedFilterParam.key === "createdAt" && (
                          <>
                            <MimaDateFilter
                              labelTitle="start date"
                              name="startDate"
                              value={!onReset ? values.startDate : ""}
                              onChange={(text) => {
                                setOnReset(false);
                                setFieldValue("startDate", text);
                              }}
                              onBlur={handleBlur}
                              width={26}
                              touched={touched.startDate}
                              error={errors.startDate}
                            />
                            <MimaDateFilter
                              labelTitle="End date"
                              name="endDate"
                              value={!onReset ? values.endDate : ""}
                              onChange={(text) => {
                                setOnReset(false);
                                setFieldValue("endDate", text);
                              }}
                              onBlur={handleBlur}
                              width={26}
                              touched={touched.endDate}
                              error={errors.endDate}
                            />
                          </>
                        )}

                        {selectedFilterParam.key === "type" && (
                          <>
                            <RCB
                              title="Expense"
                              onChange={() => {
                                setFieldValue("type", "EXPENSE");
                              }}
                              checked={values.type === "EXPENSE"}
                              value="EXPENSE"
                              name="type"
                            />
                            <RCB
                              title="Income"
                              checked={values.type === "INCOME"}
                              onChange={() => setFieldValue("type", "INCOME")}
                              value="INCOME"
                              name="type"
                            />
                            <RCB
                              title="Debt"
                              checked={values.type === "DEBT"}
                              onChange={() => setFieldValue("type", "DEBT")}
                              value="DEBT"
                              name="type"
                            />
                            {errors.type && (
                              <MimaText
                                variant="small"
                                color="var(--color-error)"
                              >
                                {errors.type}
                              </MimaText>
                            )}
                          </>
                        )}

                        {selectedFilterParam.key === "status" && (
                          <>
                            <MimaDropdownFilter
                              labelTitle="Filter by Status"
                              placeholder="Select status"
                              width={26}
                              name="status"
                              data={statusParams}
                              onChange={(data) => {
                                setFieldValue("status", data.key);
                              }}
                              error={errors.status}
                              touched={touched.status}
                            />
                          </>
                        )}
                        {selectedFilterParam.key === "business" && (
                          <>
                            <MimaPaginatedDropdown
                              type="text"
                              name="business"
                              id="business"
                              value={values.tradingName}
                              queryKey={["getAllSignedBusinesses"]}
                              optionLabel="tradingName"
                              labelTitle="Filter by Business"
                              placeholder="Select business"
                              touched={touched?.business}
                              error={errors?.business}
                              url="/businesses"
                              getPageValue={(page) =>
                                page?.data?.businesses || []
                              }
                              getPageTotalCount={(lastPage) =>
                                lastPage?.data?.count || 0
                              }
                              onChange={(data) => {
                                setFieldValue("business", data._id);
                                setFieldValue("tradingName", data.tradingName);
                              }}
                              width={26}
                            />
                          </>
                        )}
                        {selectedFilterParam.key === "from" && (
                          <MimaDropdownFilter
                            labelTitle="From Currency"
                            placeholder="Select currency"
                            width={26}
                            name="from"
                            data={[
                              { key: "NGN", value: "NGN" },
                              { key: "USD", value: "USD" },
                              { key: "GBP", value: "GBP" },
                              { key: "EUR", value: "EUR" },
                            ]}
                            onChange={(data) => setFieldValue("from", data.key)}
                            error={errors.from}
                            touched={touched.from}
                          />
                        )}

                        {selectedFilterParam.key === "to" && (
                          <MimaDropdownFilter
                            labelTitle="To Currency"
                            placeholder="Select currency"
                            width={26}
                            name="to"
                            data={[
                              { key: "NGN", value: "NGN" },
                              { key: "USD", value: "USD" },
                              { key: "GBP", value: "GBP" },
                              { key: "EUR", value: "EUR" },
                            ]}
                            onChange={(data) => setFieldValue("to", data.key)}
                            error={errors.to}
                            touched={touched.to}
                          />
                        )}

                        <div className={styles.filter__action__btns}>
                          <MimaButton
                            title="Cancel"
                            buttonColor="var(--color-error)"
                            width={10}
                            onClick={closeFilter}
                          />
                          <MimaButton
                            title="Apply Filter"
                            buttonColor="var(--color-primary)"
                            width={15}
                            onClick={handleSubmit}
                          />
                        </div>
                      </div>
                    </>
                  )}
                </Formik>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

MimaNewFilter.propTypes = propTypes;

MimaNewFilter.defaultProps = defaultProps;

export default MimaNewFilter;

// import React, { useState } from "react";
// import PropTypes from "prop-types";
// import { MimaDateFilter } from "../MimaInput";
// import { MimaButton } from "../Button";
// import { ReceiptCheckBox as RCB } from "../Receipt";
// import styles from "../../assets/styles/MimaFilter/MimaNewFilter.module.scss";
// import { Formik } from "formik";
// import MimaText from "../MimaText";
// import { MdClose } from "react-icons/md";
// import { IoMdAdd } from "react-icons/io";
// import moment from "moment";
// import { useMemo } from "react";
// import { date, object, string } from "yup";
// import { MimaDropdownFilter } from "../Dropdown";
// import { MimaPaginatedDropdown } from "../MimaPaginatedDropDown";
// import { businessStore } from "../../stores";

// const propTypes = {
//   value: PropTypes.any,
//   name: PropTypes.string,
//   variant: PropTypes.oneOf([
//     "medium",
//     "wide",
//     "form",
//     "mobile",
//     "message",
//     "exchange",
//     "form2",
//     "error",
//   ]),
//   textAreaVariant: PropTypes.oneOf(["type1", "type2", "type3"]),
//   showFilter: PropTypes.bool,
//   filterByData: PropTypes.array,
//   filterHandler: PropTypes.func,
//   statusParams: PropTypes.array,
// };

// const defaultProps = {
//   handleFilter: (item, text) => {},
//   filterByData: [
//     { value: "Date", key: "createdAt" },
//     { value: "Type", key: "type" },
//   ],
//   statusParams: [
//     { value: "Open", key: "OPEN" },
//     { value: "Closed", key: "CLOSED" },
//   ],
// };

// // Value: Name you want to display, Key: api query.

// const MimaNewFilter = ({
//   showFilter,
//   setShowFilter,
//   filterByData,
//   filterHandler,
//   statusParams,
// }) => {
//   const [onReset, setOnReset] = useState(false);
//   const [filterTags, setFilterTags] = useState([]);
//   const [selectedFilterParam, setSelectedFilterParam] = useState(
//     filterByData[0]
//   );
//   const [selectedParamIndex, setSelectedParamIndex] = useState(0);

//   const goToFilterSelection = (item, i) => {
//     setSelectedFilterParam(item);
//     setSelectedParamIndex(i);
//   };

//   const validationSchema = () => {
//     return object({
//       selectedFilter: string().required("Please select a filter option"),
//       startDate: date().when("selectedFilter", {
//         is: "createdAt",
//         then: date().required("Start date is required"),
//       }),
//       endDate: date().when("selectedFilter", {
//         is: "createdAt",
//         then: date().required("End date is required"),
//       }),
//       type: string().when("selectedFilter", {
//         is: "type",
//         then: string().required("Select a Type"),
//       }),
//       status: string().when("selectedFilter", {
//         is: "status",
//         then: string().required("Select a Status"),
//       }),
//       business: string().when("selectedFilter", {
//         is: "business",
//         then: string().required("Select a Business"),
//       }),
//     });
//   };

//   useMemo(() => {
//     const createFilterQuery = async () => {
//       let query;

//       if (filterTags.length === 1) {
//         const filter = filterTags[0];

//         if (filter.key === "createdAt") {
//           // query = `dateField=${filter.key}&startDate=${filter.startDate}&endDate=${filter.endDate}`;
//           query = `startDate=${filter.startDate}&endDate=${filter.endDate}`;
//         } else if (filter.key === "type") {
//           query = `${filter.key}=${filter.type}`;
//         } else if (filter.key === "status") {
//           query = `${filter.key}=${filter.status}`;
//         } else if (filter.key === "business") {
//           query = `${filter.key}=${filter.business}`;
//         }
//       } else if (filterTags.length > 1) {
//         // If there are multiple filters, construct the query string with all key-value pairs

//         query = filterTags
//           // eslint-disable-next-line array-callback-return
//           .map((filter) => {
//             if (filter.key === "createdAt") {
//               // return `dateField=${filter.key}&startDate=${filter.startDate}&endDate=${filter.endDate}`;
//               return `startDate=${filter.startDate}&endDate=${filter.endDate}`;
//             } else if (filter.key === "type") {
//               return `${filter.key}=${filter.type}`;
//             } else if (filter.key === "status") {
//               return `${filter.key}=${filter.status}`;
//             } else if (filter.key === "business") {
//               return `${filter.key}=${filter.business}`;
//             }
//           })
//           .join("&");
//       }

//       filterHandler(query);
//     };

//     createFilterQuery();
//   }, [filterTags, filterHandler]);

//   const onSubmit = async (values) => {
//     setShowFilter(false);
//     let newAdd;
//     if (selectedFilterParam.key === "createdAt") {
//       newAdd = {
//         ...selectedFilterParam,
//         ...values,
//         text: `Created between ${moment(values.startDate).format("MMM DD YYYY")} and ${moment(values.endDate).format("MMM DD YYYY")}`,
//       };
//       const index = filterTags.findIndex((filter) => filter.key === newAdd.key);

//       if (index === -1) {
//         setFilterTags([...filterTags, newAdd]);
//       } else {
//         const updatedFilterOptions = [...filterTags];
//         updatedFilterOptions[index].text = newAdd.text;
//         setFilterTags(updatedFilterOptions);
//       }
//     }
//     if (selectedFilterParam.key === "type") {
//       newAdd = {
//         ...selectedFilterParam,
//         ...values,
//         text: `Transaction Type - ${values.type}`,
//       };
//       const index = filterTags.findIndex((filter) => filter.key === newAdd.key);

//       if (index === -1) {
//         setFilterTags([...filterTags, newAdd]);
//       } else {
//         const updatedFilterOptions = [...filterTags];
//         updatedFilterOptions[index].text = newAdd.text;
//         setFilterTags(updatedFilterOptions);
//       }
//     }
//     if (selectedFilterParam.key === "status") {
//       newAdd = {
//         ...selectedFilterParam,
//         ...values,
//         text: `Status - ${values.status}`,
//       };
//       const index = filterTags.findIndex((filter) => filter.key === newAdd.key);

//       if (index === -1) {
//         setFilterTags([...filterTags, newAdd]);
//       } else {
//         const updatedFilterOptions = [...filterTags];
//         updatedFilterOptions[index].text = newAdd.text;
//         setFilterTags(updatedFilterOptions);
//       }
//     }
//     if (selectedFilterParam.key === "business") {
//       newAdd = {
//         ...selectedFilterParam,
//         ...values,
//         text: `Business - ${values.tradingName}`,
//       };
//       const index = filterTags.findIndex((filter) => filter.key === newAdd.key);

//       if (index === -1) {
//         setFilterTags([...filterTags, newAdd]);
//       } else {
//         const updatedFilterOptions = [...filterTags];
//         updatedFilterOptions[index].text = newAdd.text;
//         setFilterTags(updatedFilterOptions);
//       }
//     }
//   };

//   //Remove tags
//   const removeTags = (index) => {
//     setFilterTags([
//       ...filterTags.filter((tag) => filterTags.indexOf(tag) !== index),
//     ]);
//   };

//   const closeFilter = () => {
//     setShowFilter(false);
//   };

//   return (
//     <div className={styles.filter}>
//       <div className={styles.filter__tags}>
//         {filterTags.length > 0 && <>Filter Tags</>}
//         <div className={styles.tags}>
//           {filterTags.map((tag, index) => (
//             <div className={styles.singleTag} key={index}>
//               <span>{tag.text}</span>
//               <i onClick={() => removeTags(index)}>
//                 <MdClose />
//               </i>
//             </div>
//           ))}
//           <div className={styles.tagRelative}>
//             {filterTags.length > 0 && (
//               <div className={styles.singleTag}>
//                 <IoMdAdd
//                   style={{ fontSize: "2rem" }}
//                   onClick={() => setShowFilter(true)}
//                 />
//               </div>
//             )}

//             {showFilter && (
//               <div className={styles.filter__beside}>
//                 <Formik
//                   initialValues={{
//                     startDate: "",
//                     endDate: "",
//                     selectedFilter: selectedFilterParam.key,
//                     type: "",
//                     status: "",
//                     business: "",
//                     tradingName: "",
//                   }}
//                   validationSchema={validationSchema}
//                   onSubmit={onSubmit}
//                 >
//                   {({
//                     handleChange,
//                     handleBlur,
//                     handleSubmit,
//                     setFieldValue,
//                     values,
//                     errors,
//                     touched,
//                   }) => (
//                     <>
//                       <div className={styles.filter__by}>
//                         <MimaText
//                           variant="small"
//                           color="var(--color-primary)"
//                           style={{ padding: "1rem" }}
//                         >
//                           Filter by
//                         </MimaText>

//                         {filterByData.map((x, i) => (
//                           <li
//                             key={i}
//                             className={`${styles.filter__by__list} ${selectedParamIndex === i && styles.filter__by__list__active}`}
//                             onClick={() => {
//                               goToFilterSelection(x, i);
//                               setFieldValue("selectedFilter", x.key);
//                             }}
//                           >
//                             {x.value}
//                           </li>
//                         ))}
//                       </div>

//                       <div className={styles.filter__action}>
//                         {selectedFilterParam.key === "createdAt" && (
//                           <>
//                             <MimaDateFilter
//                               labelTitle="start date"
//                               name="startDate"
//                               value={!onReset ? values.startDate : ""}
//                               onChange={(text) => {
//                                 setOnReset(false);
//                                 setFieldValue("startDate", text);
//                               }}
//                               onBlur={handleBlur}
//                               width={26}
//                               touched={touched.startDate}
//                               error={errors.startDate}
//                             />
//                             <MimaDateFilter
//                               labelTitle="End date"
//                               name="endDate"
//                               value={!onReset ? values.endDate : ""}
//                               onChange={(text) => {
//                                 setOnReset(false);
//                                 setFieldValue("endDate", text);
//                               }}
//                               onBlur={handleBlur}
//                               width={26}
//                               touched={touched.endDate}
//                               error={errors.endDate}
//                             />
//                           </>
//                         )}

//                         {selectedFilterParam.key === "type" && (
//                           <>
//                             <RCB
//                               title="Expense"
//                               onChange={() => {
//                                 setFieldValue("type", "EXPENSE");
//                               }}
//                               checked={values.type === "EXPENSE"}
//                               value="EXPENSE"
//                               name="type"
//                             />
//                             <RCB
//                               title="Income"
//                               checked={values.type === "INCOME"}
//                               onChange={() => setFieldValue("type", "INCOME")}
//                               value="INCOME"
//                               name="type"
//                             />
//                             <RCB
//                               title="Debt"
//                               checked={values.type === "DEBT"}
//                               onChange={() => setFieldValue("type", "DEBT")}
//                               value="DEBT"
//                               name="type"
//                             />
//                             {errors.type && (
//                               <MimaText
//                                 variant="small"
//                                 color="var(--color-error)"
//                               >
//                                 {errors.type}
//                               </MimaText>
//                             )}
//                           </>
//                         )}

//                         {selectedFilterParam.key === "status" && (
//                           <>
//                             <MimaDropdownFilter
//                               labelTitle="Filter by Status"
//                               placeholder="Select status"
//                               width={26}
//                               name="status"
//                               data={statusParams}
//                               onChange={(data) => {
//                                 setFieldValue("status", data.key);
//                               }}
//                               error={errors.status}
//                               touched={touched.status}
//                             />
//                           </>
//                         )}
//                         {selectedFilterParam.key === "business" && (
//                           <>
//                             <MimaPaginatedDropdown
//                               type="text"
//                               name="business"
//                               id="business"
//                               value={values.tradingName}
//                               queryKey={["getAllSignedBusinesses"]}
//                               optionLabel="tradingName"
//                               labelTitle="Filter by Business"
//                               placeholder="Select business"
//                               touched={touched?.business}
//                               error={errors?.business}
//                               url="/businesses"
//                               getPageValue={(page) =>
//                                 page?.data?.businesses || []
//                               }
//                               getPageTotalCount={(lastPage) =>
//                                 lastPage?.data?.count || 0
//                               }
//                               onChange={(data) => {
//                                 setFieldValue("business", data._id);
//                                 setFieldValue("tradingName", data.tradingName);
//                               }}
//                               width={26}
//                             />
//                           </>
//                         )}

//                         <div className={styles.filter__action__btns}>
//                           <MimaButton
//                             title="Cancel"
//                             buttonColor="var(--color-error)"
//                             width={10}
//                             onClick={closeFilter}
//                           />
//                           <MimaButton
//                             title="Apply Filter"
//                             buttonColor="var(--color-primary)"
//                             width={15}
//                             onClick={handleSubmit}
//                           />
//                         </div>
//                       </div>
//                     </>
//                   )}
//                 </Formik>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// MimaNewFilter.propTypes = propTypes;

// MimaNewFilter.defaultProps = defaultProps;

// export default MimaNewFilter;
